export default __webpack_public_path__ + "static/media/outcess14.9369b846.jpeg";